export async function waitForTimeout(timeoutMs  ) {
    return new Promise((resolve, reject) => {
        setTimeout(() => resolve(), timeoutMs);
    }) 
}

export async function waitForAnimationFrame() {
    return new Promise((resolve, reject) => {
        requestAnimationFrame(resolve);
    });
}